import { lazy } from 'react';

const AnimatedLoader = lazy(() =>
  import('./loaderAnimated').then(module => ({ default: module.AnimatedLoader })),
);

export * from './loader';
export { AnimatedLoader };
